
import Vue from 'vue'

export default Vue.extend({
  name: 'Error',
  props: {
    title: {
      type: String,
      default: 'Er is een veld niet goed ingevuld'
    },
    errors: {
      type: Object
    }
  },
  computed: {
    filteredErrors(): string[] {
      const filteredErrors: any[] = []

      Object.entries(this.errors).forEach(([_, messages]) => {
        if (Array.isArray(messages) && messages.length > 0) {
          filteredErrors.push(messages[0])
        }
      });

      return filteredErrors
    },
  }
})
